export const FILENAME_RESTRICTED_SYMBOLS_REGEX = /[-^&'@{}[\],$=!#().%+~* ]/g;
